<template>
    <div class='billBox'>
        <el-row class="billCenter">
            <el-col class="borde">
                <div >
                    <el-col class="bordeLeft">{{this.$route.query.wendang}}</el-col>
                </div>
            </el-col>
        </el-row>

        <!-- 订单详情 -->
        <el-row>
          <el-row class="statusRow">
            <el-col :span="24" class="status"><div>订单状态：{{this.tableData.status}}</div></el-col>
          </el-row>
          <el-row class="center">
            <el-col :span="12" class="centerLeft"><div class="orderMsg">
              <div>
                <span>订单号：</span>
                <span>{{this.tableData.orderId}}</span>
              </div>
              <div>
                <span>票号：</span>
                <span>{{this.tableData.billNum}}</span>
              </div>
              <div>
                <span>承兑人：</span>
                <span>{{this.tableData.acceptingBank}}</span>
              </div>
              <div>
                <span>票面金额：</span>
                <span>{{this.tableData.billAmt}}元</span>
              </div>
              <div>
                <span>到期日：</span>
                <span>{{this.tableData.endDate}} {{this.tableData.subDays}}</span>
              </div>
              <div>
                <span>瑕疵情况：</span>
                <span>{{this.tableData.billFeature}} </span>
              </div>
              <div>
                <span>背书手数：</span>
                <span>{{this.tableData.bsSS}}</span>
              </div>
              <div class="line"></div>
              <div class="wrapper">
                <div class="leftside"> 
                  <div>
                    <span>每十万扣款：</span>
                    <span>{{this.tableData.tenThousandDiscount}}元</span>
                  </div>
                  <div>
                    <span>年化：</span>
                    <span>{{this.tableData.channelYearRate}}</span>
                  </div>
                  <div>
                    <span>实际转让金额：</span>
                    <span>{{this.tableData.getMony}}元</span>
                  </div>
                </div>
                <div class="right">
                  <div class="pic1">
                    <img :src='this.tableData.billFrontUrl' class="picture1">
                    <!-- {{this.tableData.billFrontUrl}} -->
                    <span @click="picture1Show">查看大图</span>
                  </div>
                  <div class="pic2">
                    <img :src='this.tableData.billBackUrl' class="picture2">
                    <!-- {{this.tableData.billBackUrl}} -->
                    <span @click="picture2Show">查看大图</span>
                  </div>
                </div>
              </div>
           
              

              </div>
            </el-col>
          <!-- 中间右侧部分 -->
            <el-col :span="12" class="centerRight">
              <el-col :span="12" class="connection">
                <div class="connectionHeader">联系方式</div>
                <div class="transferor">
                  <span class="transferorHeader">转让方联系方式</span>
                  <div>转让方名称：{{this.tableData.cmpName}}</div>
                  <div>代理人姓名：{{this.tableData.userName}}</div>
                  <div>手   机   号：{{this.tableData.mobile}}</div>
                </div>
                <div class="transferee">
                  <span class="transfereeHeader">受让方联系方式</span>
                  <div>受让方名称：{{this.tableData.channelAcctName}}</div>
                  <div>代理人姓名：{{this.tableData.channelName}}</div>
                  <div>手   机   号：{{this.tableData.channelPhone}}</div>
                </div>
              </el-col>
              <el-col :span="12" class="record">
                <div class="recordHeader">流转记录</div>
                <div class="recite" v-if="reciteIf">
                  <div class="reciteText">背书截图</div>
                    <img :src="this.tableData.bsurl" class="recitePicture">
                </div>
                <div class="sign" v-if="refuseShow">
                  <div class="signText">拒签截图</div>
                  <img :src="this.tableData.jqurl" class="signPicture">
                  <div class="">拒签理由：</div>
                  <p>{{this.tableData.jqdesc}}</p>
                </div>
                
              </el-col>
            </el-col>
          </el-row>

          <!-- 协议 -->
          <!-- <el-row class="agreement">
            <el-col :span="24">
              <el-col :span="24" class="titTop">
                  相关协议
              </el-col>
              <el-col :span="24" class="titbot">
                  <el-col :span="6" >
                      <div class="odd" @click="handleShowOne(item.companyInformationUrl)">
                          《票据应收款转让服务合同》
                      </div>
                  </el-col>
                  <el-col :span="6" >
                      <div class="odd" @click="handleShowTwo(item.personInformationUrl)">
                          《票据应收款转让服务合同》
                      </div>
                  </el-col>
                  <el-col :span="6" >
                      <div class="odd" @click="handleShowThree(item.personInformationUrl)">
                          《票据应收款转让服务合同》
                      </div>
                  </el-col>
              </el-col>
            </el-col>
          </el-row> -->
        </el-row>
        
        
        <el-dialog :visible.sync="picture1dialogVisible">
            <img width="100%" :src="this.tableData.billFrontUrl">
        </el-dialog>
        <el-dialog :visible.sync="picture2dialogVisible">
            <img width="100%" :src="this.tableData.billBackUrl">
        </el-dialog>
    </div>
</template>

<script>


export default {
    components:{

    },
    data(){
        return{
            PriceChange:false,
            oneSrc:'',
            twoSrc:'',
            dialogOne:false,
            dialogTwo:false,
            Receive:false,
            message:'',
            tableData:'',
            imgsrc1:'',
            imgsrc2:'',
            imgsrc3:'',
            imgsrc4:'',
            picture1dialogVisible:false,
            picture2dialogVisible:false,
            reciteIf:false,
            refuseShow: false,
            
        }
    },
    computed: {
      
    },
    mounted(){
        this.handleAjax()
        if(this.$route.query.code&&this.$route.query.code==1){
            this.dialogVisible=!this.dialogVisible
        }
    },

    methods:{
      picture1Show(){
        this.picture1dialogVisible = true
      },
      picture2Show(){
        this.picture2dialogVisible = true
      },
      handleAjax(){
            this.loading=true
            let detailId = this.$route.query.oId
            this.ajax.post('/jyOder/jyorderDetail',{bizContent:{orderId:detailId}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data
                            // 这个请求页的部分不是所有的数据请求都需要的
                            // add.map((item,index)=>{
                            //     add[index].xh=index+1
                            // })
                            this.tableData=add
                            if(this.tableData.bsurl == ''){
                              this.reciteIf = false
                            }else{
                              this.reciteIf = true
                            }
                            if(this.tableData.status == 630){
                              this.refuseShow = true
                            }else {
                              this.refuseShow = false
                            }
                            if(this.tableData.status == 100) {
                              this.tableData.status = '待审核'
                            }else if(this.tableData.status == 600) {
                              this.tableData.status = '待背书'
                            }else if(this.tableData.status == 610 || 620 || 630) {
                              this.tableData.status = '待签收'
                            }
                            this.total=result.data.total
                        }else{
                            }
                        }
                )
        },
      handleMoney(){
            this.$router.push({
                path:'/cashIndex'
            })
        },
      
      handleShowOne(val){
            if(val==''){
                this.$message('该授权书签约后可查看')
                return false;
            }
            let url='https://img.borntrust.com/'+val
            this.oneSrc=url
            this.dialogOne=!this.dialogOne
        },
        handleShowTwo(val){
            if(val==''){
                this.$message('该授权书签约后可查看')
                return false;
            }
            let url='https://img.borntrust.com/'+val
            this.twoSrc=url
            this.dialogTwo=!this.dialogTwo
        },
      handleCxClick(val){
            this.$confirm('您确定要撤单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.post('/dcorder/cancel',{bizContent:{orderId:val.orderId}})
                .then(
                    result=>{
                        if(result.status=='0000'){
                            this.current=1
                            this.handleAjax()
                            this.$message('撤单成功！');
                        }else{
                            this.$message(result.data.message);
                            }
                        }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消撤单'
                });
            });
        },
    },
    
}
</script>

<style  scoped>
.billBox{
    background: white;
    height: 899px;
    /* width: 1660px; */
}



.borde{
    height: 90px;
    padding-left: 34px;
    padding-top: 38px;
    /* margin-bottom: 20px; */
}

.bordeLeft{
    height:33px;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:33px;
}

.wrapper{
  display: flex;
}
/* .leftside{
  background:white;
} */
/* .left{
  background: #3E5F9C;
  height: 200px;
} */

.right{
  display: flex;
  margin-left: 30px;
}
.pic1{
  width:100px;
  height:96px;
  text-align: center;
  margin-right: 65px;
}

.pic1>>>span{
  padding-left: 40px;
  color:rgba(0,122,255,1);
}

.pic2{
  width:100px;
  height:96px;
  text-align: center;
}

.pic2>>>span{
  padding-left: 40px;
  color:rgba(0,122,255,1);
}

.picture1{
  width:153px;
  height:96px;
}

.picture2{
  width:153px;
  height:96px;
}

.odd{
    color: cornflowerblue;
    text-decoration: underline;
}
.odd:hover{
    cursor: pointer;
    color: black;
}
/* .treeBot{
    margin-top: 135px;
    text-align: center;
    height: 90px;
    line-height: 90px;
    background: #F4F6F8FF;
} */

.button{
    background: #3E5F9CFF;
    margin-top: 20px;
}

.step{
  padding-top: 56px;
  background:rgba(255,255,255,1);
  height: 184px;
}

.statusRow{
  width: 1137px;
  height:55px;
  margin-left: 20px;
  line-height: 55px;
  background:rgba(252,252,252,1);
  border-radius:4px 4px 0px 0px;
  border:1px solid rgba(227,228,229,1);
}

.status{
  height:55px;
  line-height: 55px;
  padding-left: 18px;
}

.center{
  /* background: cadetblue; */
  width:1137px ;
  margin-left: 20px;
  height: 415px;
  border:1px solid rgba(239,239,239,1);
  box-sizing: border-box;
}

.centerLeft{
  width: 577px;
  height:415px;
}
.orderMsg{
  padding-top: 9px;
  padding-left: 17px;
}
.centerRight{
  width: 557px;
  height:415px;
  box-sizing: border-box;
  /* border:1px solid rgba(239,239,239,1); */
  border-left:1px solid rgba(239,239,239,1);
}
.orderMsg>>>div{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
  margin-bottom: 14px;
}
.line{
  width:540px;
  height:2px!important;
  background: #E8E7E7;
  margin-bottom: 16px!important;
  margin-right: 50px;
}

.changePrice{
  padding-top: 160px;
  text-align: center;
  /* border: none; */
}

.changePrice>>>div{
  margin: 20px 0;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
}

.firstButton{
  border-radius:4px;
  border:1px solid rgba(58,91,160,1);
  box-sizing: border-box;
  color:#3E5F9C ;
}

.agreement{
  width:1137px;
  height:124px;
  margin-bottom: 107px;
  margin-left: 19px;
  padding-top: 24px;
  padding-left: 18px;
}
.titTop{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:17px;
  margin-bottom: 20px;
}

.waiting{
  padding-top: 196px;
  text-align: center;
}

.waitingText{
  margin-bottom: 42px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
}

.waiting>>>.el-button{
  height:35px;
  background:rgba(62,95,156,1);
  border-radius:4px;
}

.success{
  padding-top: 144px;
  text-align: center;
}
.iconWrap{
  font-size: 37px;
  color: #3E5F9C;
}

.successText{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:20px;
  margin-top: 33px;
  margin-bottom: 20px;
}

/* .recite{
  padding-top: 46px;
  text-align: center;
} */

.reciteAmount{
  height:28px;
  font-size:20px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,93,93,1);
  line-height:28px;
}

/* .reciteText{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:20px;
  margin-top: 8px;
  margin-bottom: 4px;
} */

.reciteTime{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:17px;
  margin-bottom: 33px;
}

.resignAccount{
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:22px;
  margin-bottom: 21px;
}

.bankText{
  margin-bottom: 12px;
  text-align: left;
  padding-left:40px;
}
.first{
  width:84px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
}

.second{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:20px;
}

.third{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,122,255,1);
  line-height:17px;
}

.notice{
  text-align: center;
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,93,93,1);
  line-height:17px;
  margin-bottom: 20px;
}

.howRecite{
  border: none;
  background: none;
  color: #007AFF;
  text-decoration: underline;
}

.changePrice>>>.moreWrap{
  color: #D8D8D8;
  font-size: 30px;
}

.connection{
  height: 415px;
  padding-top: 21px;
  padding-left: 36px;
  border-right: 1px solid rgba(239,239,239,1);
}

.connectionHeader{
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:22px;
  margin-bottom: 31px;
}

.transferor, .transferee{
  margin-bottom: 42px;
}

.transferorHeader, .transfereeHeader{
  display: block;
  width:98px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:20px;
  margin-bottom: 12px;
}

.transferor>>>div, .transferee>>>div{
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(85,85,85,1);
  line-height:17px;
  margin-bottom: 13px;
}

.record{
  padding-top: 21px;
  padding-left: 36px;
}

.recordHeader{
  width:64px;
  height:22px;
  font-size:16px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:22px;
  margin-bottom: 31px;
}

.recite, .sign{
  margin-bottom: 26px;
}

.reciteText, .signText{
  width:56px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(85,85,85,1);
  line-height:20px;
  margin-bottom: 7px;
}


.recitePicture, .signPicture{
  width:192px;
  height:98px;
}
</style>


// WEBPACK FOOTER //
// src/page/orderexception/orderdetail.vue